import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const resolveAppUrl = (path) => {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    return new URL(path, window.location.origin).toString();
};

export const convertDateFormat = (dateString) => {
    if (!dateString) return '';
    if (dateString.includes('-')) {
        const parts = dateString.split('-');
        if (parts.length === 3) {
            // If it's already in MM-DD-YYYY format, convert to YYYY-MM-DD
            if (parts[0].length === 2 && parts[1].length === 2) {
                return `${parts[2]}-${parts[0]}-${parts[1]}`;
            }
            // If it's already in YYYY-MM-DD format, return as is
            return dateString;
        }
    }
    return dateString;
};

export const handleAgentLogin = () => {
    const { hostname } = window.location;

    if (hostname.includes('staging2')) {
        window.location.href = 'https://staging2.leasehub.app/login';
        return;
    }
    if (hostname.includes('staging')) {
        window.location.href = 'https://staging.leasehub.app/login';
        return;
    }
    if (hostname.includes('demo')) {
        window.location.href = 'https://demo.leasehub.app/login';
        return;
    }
    window.location.href = 'https://leasehub.app/login';
};

export const handleAgentSignUp = () => {
    const { hostname } = window.location;

    if (hostname.includes('localhost')) {
        window.location.href = 'http://localhost:5173/register';
        return;
    }

    if (hostname.includes('staging2')) {
        window.location.href = 'https://agent.staging2.leasehub.app/register';
        return;
    }
    if (hostname.includes('staging')) {
        window.location.href = 'https://agent.staging.leasehub.app/register';
        return;
    }
    if (hostname.includes('demo')) {
        window.location.href = 'https://agent.demo.leasehub.app/register';
        return;
    }
    window.location.href = 'https://agent.leasehub.app/register';
};

export const getAgentSignUpLink = () => {
    if (import.meta.env.VITE_AGENT_APP_URL) {
        const base = import.meta.env.VITE_AGENT_APP_URL.replace(/\/$/, '');
        return `${base}/register`;
    }
    const { hostname } = window.location;
    const isLocalhost =
        hostname === 'localhost' ||
        hostname === '127.0.0.1' ||
        hostname.endsWith('.localhost');
    if (isLocalhost) {
        return 'http://localhost:5173/register';
    }
    const isStaging2 = hostname.includes('staging2');
    const isStaging = hostname.includes('staging') && !hostname.includes('staging2');
    const isDemo = hostname.includes('demo');
    const signupUrl = isStaging2
        ? 'https://agent.staging2.leasehub.app/register'
        : isStaging
            ? 'https://agent.staging.leasehub.app/register'
            : isDemo
                ? 'https://agent.demo.leasehub.app/register'
                : 'https://agent.leasehub.app/register';
    return signupUrl;
};

export const getAgentDashboardLink = () => {
    if (import.meta.env.VITE_AGENT_APP_URL) {
        return import.meta.env.VITE_AGENT_APP_URL;
    }
    const { hostname } = window.location;
    const isLocalhost = hostname.includes('localhost');
    if (isLocalhost) {
        return 'http://localhost:5173';
    }
    const isStaging2 = hostname.includes('staging2');
    const isStaging = hostname.includes('staging') && !hostname.includes('staging2');
    const isDemo = hostname.includes('demo');
    const dashboardUrl = isStaging2
        ? 'https://agent.staging2.leasehub.app/'
        : isStaging
            ? 'https://agent.staging.leasehub.app/'
            : isDemo
                ? 'https://agent.demo.leasehub.app/'
                : 'https://agent.leasehub.app/';
    return dashboardUrl;
};
